<script lang="ts" setup>
import MateCard from "@/components/mobile/MateCard.vue";
import ThreadsNav from "@/components/mobile/ThreadsNav.vue";
import { useChatSession } from "@/stores/chatSession";
import { useMate } from "@/stores/mate";
import { Mate } from "@/types/entity";
import { useRouteParams } from "@vueuse/router";
import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

const router = useRouter();
const loading = ref(false);
const mate = ref<Mate | null>(null);

const routeName = "mateChatList";
const mateStore = useMate();
const route = useRoute();

const mateUuid = useRouteParams("uuid", "");

const chatSessionStore = useChatSession();
const prepareData = async () => {
  loading.value = true;
  try {
    mate.value = await mateStore.getOrFetchMate(mateUuid.value);
    await chatSessionStore.getOrFetchSessionByMateId(mate.value.id);
  } finally {
    loading.value = false;
  }
};

watch(
  mateUuid,
  async (newVal, oldVal) => {
    if (
      route.name !== routeName ||
      !newVal ||
      newVal === oldVal ||
      loading.value
    )
      return;
    loading.value = true;
    await prepareData();
  },
  {
    immediate: true,
  }
);
</script>
<template>
  <div class="h-full grid grid-rows-[auto_1fr] overflow-hidden">
    <threads-nav :show-center="false" show-back />
    <div v-if="loading" class="flex items-center justify-center">
      <div class="loading loading-sm"></div>
    </div>
    <div v-else class="flex flex-col overflow-y-auto">
      <!-- 这个外层div只是为了出滚动条 -->
      <div>
        <mate-card
          :enable-btn-group="false"
          :mate="mate!"
          :show-chat-btn="false"
          class="rounded-none cursor-pointer lg:max-h-[12rem]"
          @click="
            router.push({
              name: 'mateHome',
              params: { uuid: mate!.uuid },
            })
          "
        />
        <mate-chat-list v-if="mate" :mate="mate" />
      </div>
    </div>
  </div>
</template>
